import { ITicketPopup } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/reducer';
import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetTicketPopup = IAction<ETicketPayment.SET_TICKET_POPUP_STATE, ITicketPopup>

const setTicketPopup = (popupState: ITicketPopup): TSetTicketPopup => ({
    type: ETicketPayment.SET_TICKET_POPUP_STATE,
    payload: popupState,
});

export default setTicketPopup;
